import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-shell" }
const _hoisted_2 = { class: "app-content" }

import {
	computed,
	onMounted,
	watch
} from "vue";
import { useRoute } from "vue-router";
import { useSignalR } from "@/composables/useSignalR";
import { useDocumentTitle } from "@/composables/useDocumentTitle";
import { useSoundAlert } from "@/composables/useSoundAlert";
import { useAngularBridge } from "@/composables/useAngularBridge";
import { rootStore } from "@/store/index";
import AppNotificationContainer from "@/components/ui-kit/notifications/AppNotificationContainer.vue";
import AppUploadQueuePanel from "@/components/ui-kit/upload/AppUploadQueuePanel.vue";
import AppHeader from "@/components/layout/AppHeader/AppHeader.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const root = rootStore()
const { init: initSignalR } = useSignalR()

useDocumentTitle()
// Звуки создаём сразу, а не при первом событии сокета: на телефоне их разблокирует первое же касание.
useSoundAlert()
// Приём сообщений от Angular-гостя: язык, сессия, переходы на Клиента/Проекта.
useAngularBridge()

const isLoginRoute = computed(() => route.path === '/login')

let signalRStarted = false
const startSignalROnce = () => {
	if (!signalRStarted && root.jwtToken) {
		signalRStarted = true
		initSignalR()
	}
}
onMounted(() => startSignalROnce())
watch(() => root.jwtToken, () => startSignalROnce())

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isLoginRoute.value)
      ? (_openBlock(), _createBlock(AppHeader, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_router_view),
      _createVNode(AppNotificationContainer),
      _createVNode(AppUploadQueuePanel)
    ])
  ]))
}
}

})